

(function () {
  const gallery = /** @type {HTMLElement | null} */ (
    document.querySelector(".producer-gallery")
  );
  const grid = gallery
    ? /** @type {HTMLElement | null} */ (
        gallery.querySelector(".producer-gallery-grid")
      )
    : null;
  const prevButton = gallery
    ? /** @type {HTMLButtonElement | null} */ (
        gallery.querySelector(".producer-gallery-btn--prev")
      )
    : null;
  const nextButton = gallery
    ? /** @type {HTMLButtonElement | null} */ (
        gallery.querySelector(".producer-gallery-btn--next")
      )
    : null;

  if (!gallery || !grid || !prevButton || !nextButton) {
    return;
  }

  const getScrollStep = () => {
    const firstItem = /** @type {HTMLElement | null} */ (
      grid.querySelector(".producer-gallery-item")
    );
    if (!firstItem) {
      return grid.clientWidth;
    }
    const styles = window.getComputedStyle(grid);
    const gapValue = styles.columnGap || styles.gap || "0";
    const gap = Number.parseFloat(gapValue) || 0;
    return firstItem.clientWidth + gap;
  };

  /**
   * @param {number} direction
   */
  const scrollByStep = (direction) => {
    grid.scrollBy({
      left: direction * getScrollStep(),
      behavior: "smooth",
    });
  };

  prevButton.addEventListener("click", () => scrollByStep(-1));
  nextButton.addEventListener("click", () => scrollByStep(1));
})();